module.exports = __webpack_public_path__ + "static/img/training.1e00727c.svg";